import { sum } from "d3-array";

const sumRow = (row) => {
  const rowValues = Object.values(row).slice(1); // exclude direction
  const rowTowal = sum(rowValues.map(Number))

  return rowTowal
}

const makeTableData = ({ directions, bins, empty = false }) => {
  if (!directions || !directions.length) throw Error("Directions array can't be empty or undefined");
  if (!bins || !bins.length) throw Error("Directions array can't be empty or undefined");

  const constructedData = [];
  
  for (const direction of directions) {
    const row = { angle: direction };
    
    for (const bin of bins) {
      const rowValue = empty
      ? Number(0)
      : Math.floor(Math.random() * Math.floor(5));
      row[bin] = rowValue;
    }
    
    row.total = sumRow(row);

    constructedData.push(row);
  }

  return constructedData;
};

const makeBinsObj = (bins) => ({
  Header: "Bins",
  columns: [
    ...bins.map((bin) => ({
      Header: bin,
      accessor: bin,
    })),
  ],
});

const makeTableColumns = (bins) => [
  {
    Header: "Direction",
    columns: [
      {
        Header: "",
        accessor: "angle", // TODO: make name agnostic? extra parameter? always take first column header?
        Cell: ({ value }) => String(value)
      },
    ],
  },
  makeBinsObj(bins),
  {
    Header: "Total",
    columns: [
      {
        Header: "",
        accessor: "total",
        Cell: ({ value }) => String(value)
      }
    ]
  }
];

export { makeTableColumns, makeTableData, sumRow };
